import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP_PRIMARY, waLink } from "../siteConfig";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PLACEHOLDER = "/images/car-placeholder.webp";

export function carPhotoUrl(car, idx = 0) {
  const ids = car.photo_ids || [];
  return ids.length > 0 ? `${API}/cars/${car.id}/photos/${ids[idx]}` : PLACEHOLDER;
}

export function carName(car) {
  return `${car.make} ${car.model} ${car.year}`;
}

export default function CarCard({ car, index = 0 }) {
  const { t } = useLang();
  const n = t("nx.cars");
  const status = n.statusLabels[car.status] || car.status;
  const location = n.locationLabels[car.location] || car.location;
  const msg = `${t("whatsapp.msg")} — ${carName(car)}`;

  return (
    <div className="group border border-white/10 bg-[#0A0B0C] flex flex-col h-full hover:border-white/25 transition-colors duration-500" data-testid={`car-card-${car.id}`}>
      <Link to={`/cars/${car.id}`} className="relative block overflow-hidden" aria-label={carName(car)}>
        <img
          src={carPhotoUrl(car)}
          alt={`${carName(car)} — ${location}`}
          width="800" height="500"
          loading={index < 3 ? "eager" : "lazy"}
          className="w-full aspect-[8/5] object-cover group-hover:scale-[1.03] transition-transform duration-700"
          onError={(e) => { if (!e.currentTarget.src.endsWith(PLACEHOLDER)) e.currentTarget.src = PLACEHOLDER; }}
        />
        <span
          className={`absolute top-3 left-3 mono text-[9px] tracking-[0.2em] uppercase px-2.5 py-1.5 border backdrop-blur-sm ${
            car.status === "available" ? "border-[#D1C7BD]/60 text-[#D1C7BD] bg-[#050607]/70"
            : car.status === "reserved" ? "border-white/40 text-[#F3F3F0] bg-[#050607]/70"
            : "border-white/15 text-[#666663] bg-[#050607]/70"
          }`}
          data-testid={`car-status-${car.id}`}
        >
          {status}
        </span>
      </Link>
      <div className="p-6 md:p-7 flex flex-col grow">
        <h3 className="mono text-[13px] tracking-[0.18em] text-[#F3F3F0] uppercase">{carName(car)}</h3>
        <p className="mono text-[10px] tracking-[0.14em] text-[#666663] uppercase mt-2">
          {Number(car.mileage_km).toLocaleString()} {n.km} · {t("sell.fuelOpts")[car.fuel] || car.fuel} · {t("sell.transOpts")[car.transmission] || car.transmission}
        </p>
        <p className="mono text-[12px] text-[#D1C7BD] mt-4">
          {Number(car.price_aed).toLocaleString()} AED · {Number(car.price_eur).toLocaleString()} EUR
        </p>
        <p className="mono text-[9px] tracking-[0.16em] text-[#555654] uppercase mt-1">{location}</p>
        <div className="flex flex-col sm:flex-row gap-2 mt-6 pt-5 border-t border-white/10">
          <a href={waLink(WHATSAPP_PRIMARY, msg)} target="_blank" rel="noopener noreferrer" className="btn !py-2 !px-4 justify-between" data-testid={`car-whatsapp-${car.id}`}>
            <span className="!text-[10px]">{n.whatsBtn}</span><span aria-hidden="true">→</span>
          </a>
          <Link to={`/cars/${car.id}`} className="btn btn-solid !py-2 !px-4 justify-between" data-testid={`car-inquire-${car.id}`}>
            <span className="!text-[10px]">{n.inquire}</span><span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
